function formatLatinAddressDto (address) {
  return getLocalizedAddress(address, false)
}

function formatArabicAddressDto (address) {
  return getLocalizedAddress(address, true)
}

function formatAddressDto (address, localizeValue) {
  if (!address) return ''

  const street = localizeValue(address.street, address.latinStreet)
  const city = localizeValue(address.city, address.latinCity)
  const province = localizeValue(address.province.name, address.province.latinName)
  const country = localizeValue(address.country.name, address.country.latinName)
  const nearestLandmark = localizeValue(address.nearestLandmark, address.latinNearestLandmark)

  return formatAddress({ street,
    houseNumber: address.houseNumber,
    buildingNumber: address.buildingNumber,
    zipCode: address.zipCode,
    city,
    province,
    country,
    nearestLandmark
  })
}

function getLocalizedAddress (address, ar) {
  if (!address) return ''

  const street = ar ? address.street || address.latinStreet : address.latinStreet || address.street
  const city = ar ? address.city || address.latinCity : address.latinCity || address.city
  const province = address.province ? ar ? address.province.name || address.province.latinName : address.province.latinName || address.province.name : null
  const country = address.country ? ar ? address.country.name || address.country.latinName : address.country.latinName || address.country.name : null
  const nearestLandmark = ar ? address.nearestLandmark || address.latinNearestLandmark : address.latinNearestLandmark || address.nearestLandmark

  return formatAddress({ street,
    houseNumber: address.houseNumber,
    buildingNumber: address.buildingNumber,
    zipCode: address.zipCode,
    city,
    province,
    country,
    nearestLandmark
  })
}

function formatAddress ({ street, houseNumber, buildingNumber, zipCode, city, province, country, nearestLandmark }) {
  const fullAddress = []

  const number = houseNumber && buildingNumber ? `${houseNumber}/${buildingNumber}` : houseNumber || buildingNumber

  fullAddress.push(street ? `${street} ${number}` : nearestLandmark)
  if (zipCode) fullAddress.push(zipCode)
  if (city) fullAddress.push(city)
  if (province) fullAddress.push(province)
  if (country) fullAddress.push(country)

  return fullAddress.join(', ')
}

export { formatAddressDto, formatArabicAddressDto, formatLatinAddressDto, formatAddress }



// WEBPACK FOOTER //
// ./src/utils/addressFormatter.js